import { render } from "./PackageModal.vue?vue&type=template&id=87b8e118"
import script from "./PackageModal.vue?vue&type=script&lang=js"
export * from "./PackageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/direct_mail/PackageModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87b8e118"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87b8e118', __exports__)) {
    api.reload('87b8e118', __exports__)
  }
  
  module.hot.accept("./PackageModal.vue?vue&type=template&id=87b8e118", () => {
    api.rerender('87b8e118', render)
  })

}


export default __exports__